import React from 'react'
import SecondaryBth from './SecondaryBth'
import { Link } from 'react-router-dom'

const SimpleCard = ({title,pera,amt,off,amount,secondpera,imgUrl,threepera,fourpera,start}) => {
  return (
    <div className="col-md-4">
        <div className="yearly" style={{boxShadow:'0px 0px 6px 1px #00000030',borderRadius:'7px',borderTop:'10px solid #1A2E84',backgroundColor:'#fff'}}>
            <h4 style={{fontWeight:'600',lineHeight:'40px',color:'#2E2E2E'}}>{title}</h4>
            <p style={{fontSize:'14px',color:'#696868'}}>{pera}</p>
            <div className="start">
                <p style={{color:'#2E2E2E',marginBottom:'6px'}}>{start}</p>
                <div className="dis">
                    <span className="amt mr-3" style={{color:'#707070',fontWeight:'600'}}>{amt}</span>
                    <span className="off" style={{borderRadius:'3',backgroundColor:'#70707047',color:'#707070',padding:'2px 0px'}}>{off}</span>
                </div>
                <div className="amount">
                    <h2 className='mt-3' style={{fontWeight:'600'}}>{amount}</h2>
                    <p style={{color:'#479AE8'}}>{secondpera}</p>
                </div>
                <div className="point d-flex align-items-center mb-3 pb-3" style={{borderBottom:'1px solid #00000024'}}>
                    <img src={imgUrl} alt='cardImage' />
                    <p className='mb-0 ml-3' style={{color:'#696868', border:'0',borderBottom:'1px solid #00000047',borderStyle:'dashed'}}>{threepera}</p>
                </div>
                <div className="point d-flex align-items-center mb-3 pb-3" style={{borderBottom:'1px solid #00000024'}}>
                <img src={imgUrl} alt='cardImage' />
                    <p className='mb-0 ml-3' style={{color:'#696868', border:'0',borderBottom:'1px solid #00000047',borderStyle:'dashed'}}>{fourpera}</p>
                </div>
                <div className="start-btn mt-5">
                        <SecondaryBth path='/Pricing' titleTwo="Get Started "/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SimpleCard
